export const getProvinceCodeTranslationKey = (provinceCode: string) => `com.address.province.${provinceCode}`;
